<template>
  <div v-reportView:load="{ pageload: 1, pagetype: 1 }" class="home">
    <ConvertList />
    <Advantage />
  </div>
</template>

<script>
import ConvertList from './ConvertList.vue'
import Advantage from './Advantage.vue'

export default {
  name: 'Home',

  components: {
    ConvertList,
    Advantage
  }
}
</script>
<style lang="scss" >
  @import '~@/assets/scss/home_icons.scss';

  .home { margin-top: 20px; }
</style>
